import styled from '../../../../consts/styled';
import { media, spacing } from '../../../../App/ChakraTheme';

import { getUnitRoute, getModuleRoute, getContentRoute } from './helpers';

import UnitPageUnStyled from './UnitPageUnStyled';

const UnitPage: any = styled(UnitPageUnStyled)`
  padding: 0 ${spacing.BASE_PLUS};
  justify-content: center;
  align-items: center;
  height: calc(100vh - 50px);

  @media (max-height: 900px) {
    height: calc(100vh + 140px);
  }

  ${media.tablet`
  .hide-tablet{display:none;}
`};
  ${media.phone`
  .hide-phone{display:none;}
`};

  .content-controls {
    flex-wrap: wrap;
    flex-shrink: 0;
    a {
      ${media.contentToolbar`
      margin: 0px;
      `}
    }
    button.chakra-button {
      ${media.contentToolbar`
      margin: 4px;
      `}
      ${media.contentToolbarLg`
      font-size: 11px;
      `}
      ${media.contentToolbarMid`
      font-size: 11px;
      .chakra-button__icon  {
        margin-right: 4px;
        width: 18px !important;
        height: 18px !important;
      }
      `}
      ${media.contentToolbarIconsOnly`
      // padding: 0px;
      min-width: auto !important;
      min-height: auto !important;
      min-width: ${spacing.LARGE} !important;
      height: ${spacing.LARGE} !important;
      flex-shrink: 0 !important;
      justify-content: center;
      align-items: center;
      span.hide-tablet:not(.unshare) {
        display: none;
      }
      .chakra-button__icon {
        margin: 0 !important;
        flex-shrink: 0;
      }
    `}
    }
  }

  .module {
    width: 100%;
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: auto;
    padding-right: 15px;
    position: relative;

    &:not(:last-of-type) .module-title:after,
    .module-title.active-module:after {
      content: '';
      height: calc(100% - 44px);
      width: 1px;
      position: absolute;
      background-color: rgba(213, 214, 222, 0.2);
      left: 21px;
      top: 43px;
      z-index: 0;
    }
  }
  :not(json_cms_content) iframe:not(.embed-block-custom-width),
  :not(json_cms_content) canvas {
    width: 100% !important;
    flex-grow: 1;
    flex-basis: 100vh !important;
  }

  :not(json_cms_content)
    iframe:not(.cms_content):not(.youtube_iframe):not(.embed-block),
  :not(json_cms_content) canvas {
    height: 100vh !important;
  }

  :not(json_cms_content) iframe.embed-block {
    height: 100vh;
  }

  .cms_content {
    border: none;
    overflow: hidden;
    width: 100% !important;
    -webkit-flex-basis: auto !important;
  }

  iframe:fullscreen,
  iframe:-webkit-full-screen {
    width: 100vw !important;
    height: 100vh !important;
    padding: 0;
    overflow: scroll;
  }

  .cms_content_container {
    overflow: hidden;
    background: #fff;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    margin-bottom: 60px;
  }

  .cms_content_container:fullscreen div:first-of-type {
    display: none;
  }

  .complete-btn:hover {
    background-color: #75d640;
  }
`;

UnitPage.unit = { getRoute: getUnitRoute };
UnitPage.module = { getRoute: getModuleRoute };
UnitPage.content = { getRoute: getContentRoute };

export default UnitPage;

export { UnitPage };
